const firebaseConfig = {
    apiKey: "AIzaSyCWwbTEprKUo-rtX7ke_29OulEI7K9tr_s",
    authDomain: "tourism-9a710.firebaseapp.com",
    projectId: "tourism-9a710",
    storageBucket: "tourism-9a710.appspot.com",
    messagingSenderId: "11834688498",
    appId: "1:11834688498:web:36daf7d4b9a75dda0ba16b"
};
export default firebaseConfig;